import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import "./About.scss";

function About() {
  const { t } = useTranslation();

  const sections = [
    {
      id: "confession",
      icon: "🕊️",
      title: t("about_enhanced.confession_title"),
      shortDesc: t("about_enhanced.confession_short"),
      longDesc: t("about_enhanced.confession_long"),
    },
    {
      id: "app",
      icon: "⛪",
      title: t("about_enhanced.about_app_title"),
      shortDesc: t("about_enhanced.about_app_short"),
      longDesc: t("about_enhanced.about_app_long"),
    },
    {
      id: "privacy",
      icon: "🔒",
      title: t("about_enhanced.privacy_title"),
      shortDesc: t("about_enhanced.privacy_short"),
      longDesc: t("about_enhanced.privacy_long"),
    },
    {
      id: "opensource",
      icon: "💻",
      title: t("about_enhanced.opensource_title"),
      shortDesc: t("about_enhanced.opensource_short"),
      longDesc: t("about_enhanced.opensource_long"),
    },
  ];

  const features = [
    {
      icon: "📱",
      title: t("about_enhanced.feature_mobile"),
    },
    {
      icon: "🌐",
      title: t("about_enhanced.feature_offline"),
    },
    {
      icon: "🌍",
      title: t("about_enhanced.feature_languages"),
    },
    {
      icon: "🔐",
      title: t("about_enhanced.feature_private"),
    },
  ];

  return (
    <div className="about-page">
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            {/* Header */}
            <div className="text-center mb-5">
              <div className="about-icon">⛪</div>
              <h1 className="about-title">Confiésalo</h1>
              <p className="about-subtitle">{t("about_enhanced.subtitle")}</p>
            </div>

            {/* Features Grid */}
            <div className="features-grid mb-5">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon-small">{feature.icon}</div>
                  <span className="feature-text">{feature.title}</span>
                </div>
              ))}
            </div>

            {/* Main Sections */}
            <Accordion defaultActiveKey="0" className="about-accordion">
              {sections.map((section, index) => (
                <Accordion.Item eventKey={index.toString()} key={section.id}>
                  <Accordion.Header>
                    <div className="section-header">
                      <span className="section-icon">{section.icon}</span>
                      <span className="section-title">{section.title}</span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="section-short">{section.shortDesc}</p>
                    <div className="section-long">{section.longDesc}</div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>

            {/* Quick Links */}
            <div className="links-section mt-5">
              <h3 className="links-title">{t("about_enhanced.links_title")}</h3>
              <div className="links-grid">
                <a href="https://github.com/dexstar007/Confiesalo" target="_blank" rel="noopener noreferrer" className="link-card">
                  <i className="fa fa-github"></i>
                  <span>GitHub</span>
                </a>
                <a href="https://www.opensourcecatholic.com/" target="_blank" rel="noopener noreferrer" className="link-card">
                  <i className="fa fa-comments"></i>
                  <span>Open Source Catholic</span>
                </a>
                <a href="https://masstimes.org/" target="_blank" rel="noopener noreferrer" className="link-card">
                  <i className="fa fa-church"></i>
                  <span>MassTimes</span>
                </a>
                <a href="https://www.vatican.va/" target="_blank" rel="noopener noreferrer" className="link-card">
                  <i className="fa fa-globe"></i>
                  <span>Vatican</span>
                </a>
              </div>
            </div>

            {/* Footer Note */}
            <Card className="footer-card mt-5">
              <Card.Body className="text-center">
                <p className="mb-0 footer-text">{t("about_enhanced.footer_note")}</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;
